import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { GlassCard, Button } from '../components/ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col w-full min-w-0">
      <Header />

      <main className="flex-1 w-full min-w-0 container mx-auto px-4 py-8 flex items-center justify-center max-w-full">
        <GlassCard
          className="p-8 md:p-12 max-w-lg w-full text-center"
          hoverable={false}
        >
          <div className="mb-6">
            <span className="text-8xl font-bold text-gray-200">404</span>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Page Not Found
          </h1>

          <p className="text-gray-600 mb-8">
            The page you&apos;re looking for doesn&apos;t exist or has been
            moved.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="secondary"
              onClick={() => navigate(-1)}
              icon={<ArrowLeft className="w-5 h-5" />}
            >
              Go Back
            </Button>
            <Button onClick={() => navigate('/')} icon={<Home className="w-5 h-5" />}>
              Homepage
            </Button>
          </div>
        </GlassCard>
      </main>

      <Footer />
    </div>
  );
}
